<div class="row"  *ngIf="(myQuiz && !loading)">
  <div class="col-sm-12">
      <div class="card">
          <div class="card-header">
              <h1  class="text-center">{{subscriptionGrouping['name']}}</h1>
              <h2 id="quizInfo" class="text-center">Quiz for {{subscriptionGrouping['subject_name']}}:{{subscriptionGrouping['level_name']}}</h2>
              <h3 id="quizDate" class="text-center">Date:{{myQuiz['datecreated']}}</h3>
          </div>
          <div class="card-body">
              <div  *ngIf="myQuiz" class="table-responsive">
                  <table class="table table-striped table-borderless">
                    <tbody>
                        <tr *ngFor="let question of  myQuiz.questions; index as myCount;">

                          <td id="myquestion_{{question.server_question_id}}">
                            <app-show-question
                            (renderMathRequest)="renderMathPage($event)"


                            [imageQuestionsCount]="imageQuestionsCount"
                            [question]="question"
                            [myCount]="myCount"
                            [myQuiz]="myQuiz"
                            [isGrouping]="isGrouping"> </app-show-question>

                        </td>
                        </tr>

                    </tbody>
                  </table>
               </div>
          </div>
          <div class="card-footer">
              <fieldset class="buttons text-center">

                  <a [routerLink]="['/batch/grouping/quiz/list',server_subscription_grouping_id]"
                      class="btn btn-outline-primary margin-50-right">
                      <i class="fa fa-home"></i>Home
                 </a>


                  <button (click)="downloadPdf(myQuiz['server_quiz_envelop_id'])"
                      class="btn btn-outline-primary">
                      <i *ngIf="!downloading" class='fa fa-file-pdf-o'></i>
                      <span *ngIf="downloading" class="spinner-border spinner-border-lg me-1 text-info"></span>
                      <span [appMath]="' Worksheet'" *ngIf="renderMathNow"></span>
                  </button>
              </fieldset>
          </div>
      </div>
</div>
</div>
<app-spinner *ngIf="loading"></app-spinner>
